import { CoreLogService } from "../log.service";

/** Lifecycletrigger für Plattformevents */

export interface Lifecycletrigger {

   /**
   * Deprecated: Übermittelt der Plattform das die Universelle App bereit zur Darstellung und für Schnittsellenaufrufe ist
   */
  //appReady(): void
}

/**
* Standardimplementierung
*/
export class LifecycletriggerDefault implements Lifecycletrigger {

  /** Lifecycletrigger für Plattformevents */
  constructor(private _coreLogService: CoreLogService) {}

  /**
   * Deprecated: Übermittelt der Plattform das die Universelle App bereit zur Darstellung und für Schnittsellenaufrufe ist
   */
  //public appReady() {}
}
